
export const ValidateBillOfMaterialInput = (billOfMaterial, _createErrorMessage) => {
  if (!billOfMaterial) {
    _createErrorMessage("65");
    return false;
  }

  return true;
};
